__turbopack_context__.v({
  "Content": "qmJ7QG_Content",
  "Header": "qmJ7QG_Header",
  "Main": "qmJ7QG_Main",
  "Root": "qmJ7QG_Root",
  "Sidebar": "qmJ7QG_Sidebar",
  "skeleton-loading": "qmJ7QG_skeleton-loading",
});
